import styled, { css } from "styled-components";

const Cell = styled.div`
  flex: 1 1 15%;
  font-size: 16px;
  min-width: 70px;
  text-align: right;
  
  &:nth-child(1) {
    max-width: 3.6em;
    min-width: 3.6em;
    text-align: left;
    ${({ fullWidth }) =>
      fullWidth &&
      css`
        flex: 1 1 100%;
        max-width: 100%;
        text-align: center;
        font-weight: bold;
        color: #888;
        font-size: 0.75em;

       
  @media only screen and (min-width: 415px) {
    font-size: .8em;
  }
      `}
  }
  &:nth-child(2) {
    flex: 1 1 49%;
    max-width: none;
    text-align: left;
    display: flex;
  }

  font-weight: ${({ bold }) => (bold ? "bold" : "normal")};

  @media only screen and (max-width: 320px) {
    font-size: 0.9em;
  }
  @media only screen and (min-width: 415px) {
    min-width: 90px;
    font-size: 1.2em;
  }
`;

export default Cell;
